
import { Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";
export default class TableActionButton extends Vue {
  @Prop({ type: String }) title = "Button";
  @Prop({ type: String }) color: "primary" | "default" | "secodary" | "danger" = "default";
  @Prop({ type: Number }) width = 100;
  @Prop({ type: Boolean }) disabled?: boolean = false;
}
